import MoneyInput from 'components/MoneyInput';
import React from 'react';
import {
  getInheritedSettings,
  getSourceAndLabel,
  updateProRateCents,
} from '../PositionRateSettingsForm.utils';
import { DisplayHelpers } from 'utils/helpers';
import { useFormContext } from 'react-hook-form';
import { isNil } from 'lodash';

type Props = {
  source: string;
  show12hRatesFields: boolean;
  inheritedSettings: any;
};

export const ChargeRateCentsInput = ({ source, show12hRatesFields, inheritedSettings }: Props) => {
  const { watch, setValue } = useFormContext();
  const mergedSettings = getInheritedSettings({ source, inheritedSettings, watch });
  const { field } = getSourceAndLabel(source);

  let applicableField = field;

  if (source.includes('w2.local')) {
    applicableField = 'base_margin_percent_w2';
  }

  const baseMarginPercent =
    watch(`${source}.${applicableField}`) || mergedSettings?.[applicableField];

  const { use_blended_rate } = mergedSettings;
  const markup = watch(`${source}.blended_rates.blended_rate_markup`);

  function onChangeChargeRate(event: React.FocusEvent<HTMLInputElement>) {
    const chargeRateCents = DisplayHelpers.stringToCents(event.target.value);
    const blendedRateCents = Math.round(chargeRateCents * (1 + markup));

    if (!isNil(markup) && markup >= 0) {
      setValue(`${source}.blended_rate_cents`, blendedRateCents);
    }

    if (use_blended_rate === false && baseMarginPercent) {
      updateProRateCents({
        setValue,
        watch,
        source,
        baseMarginPercent,
        rateCents: chargeRateCents,
        inheritedSettings,
      });
    }

    if (use_blended_rate === true && blendedRateCents && baseMarginPercent) {
      updateProRateCents({
        setValue,
        watch,
        source,
        baseMarginPercent,
        rateCents: blendedRateCents,
        inheritedSettings,
      });
    }
  }

  return (
    <MoneyInput
      source={`${source}.charge_rate_cents`}
      label={show12hRatesFields ? '8hr Charge Rate' : 'Location Rate'}
      onChange={onChangeChargeRate}
    />
  );
};
